import axios from "axios";

export default {
  get(paginationString) {
    if (paginationString) {
      return axios.get(`/api/StrykerCommands${paginationString.text}`);
    } else {
      return axios.get("/api/StrykerCommands");
    }
  },
  getCommands(id) {
    return axios.get(`/api/strykerCommands/by-customer/${id}`);
  },
  recalculateColumns() {
    return axios.post("/api/strykerCommands/recalculate-custom-columns");
  },
  getCommandsWithQuery(query) {
    return axios.get(`/api/strykerCommands/by-customer/${query.customerId}`, {
      params: query,
    });
  },
};
